import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { addItemSolicitud, deleteItemSolicitud, deleteItemSolicitudCompletamente } from "../../../redux/actions/solicitud";
import noImageIcon from '../../../images/no-image-icon.svg';
import { mediaUrl } from '../../../api/client';
import { FaMinus, FaPlus, FaTrash } from 'react-icons/fa';
import styles from '../CartDrawer/CartDrawer.module.css';
const CartItem = ({
    producto,
    itemsCarrito,
    addItemSolicitud,
    deleteItemSolicitud,
    deleteItemSolicitudCompletamente,
    allProductos // New prop from Redux store
}) => {
    const [cantidad, setCantidad] = useState(0);

    useEffect(() => {
        if (itemsCarrito) {
            const itemInCarrito = itemsCarrito.find(item => item.producto.id === producto.id);
            if (itemInCarrito) {
                setCantidad(itemInCarrito.cantidad);
            } else {
                setCantidad(0);
            }
        }
    }, [itemsCarrito, producto.id]);

    const incrementarCantidad = () => {
        // Find the full product data from allProductos
        const fullProductData = allProductos.find(p => p.id === producto.producto.id);
        
        if (fullProductData && cantidad < fullProductData.cantidad) {
            addItemSolicitud(fullProductData, producto.producto);
        } else {
            console.error(`No se puede agregar más del producto ${producto.id}. Cantidad máxima alcanzada.`);
        }
    };

    const eliminarProducto = () => {
        deleteItemSolicitudCompletamente(producto);
        setCantidad(0);
    };

    const getImageUrl = (imagePath) => mediaUrl(imagePath) || noImageIcon;

    const imageUrl = producto.image 
        ? getImageUrl(producto.image.image) 
        : (Array.isArray(producto.producto.images) && producto.producto.images[0] && producto.producto.images[0].image 
            ? getImageUrl(producto.producto.images[0].image) 
            : noImageIcon);

    // Tope de unidades: el stock del producto en el catálogo (el + no hace nada al llegar)
    const fullProductData = (allProductos || []).find(p => p.id === producto.producto.id);
    const atMax = Boolean(fullProductData) && cantidad >= fullProductData.cantidad;
    const nombre = producto.producto.equipo;

    return (
        <li className={styles.item}>
            <img className={styles.itemImage} src={imageUrl} alt="" />
            <div className={styles.itemBody}>
                <p className={styles.itemName}>{nombre}</p>
                <div className={styles.itemCounter}>
                    <button
                        type="button"
                        className={`${styles.counterButton} ${styles.deleteButton}`}
                        onClick={() => deleteItemSolicitud(producto,producto.producto,0)}
                        aria-label={`Quitar ${nombre} del carrito`}
                    >
                        <FaTrash aria-hidden="true" />
                    </button>
                    <button
                        type="button"
                        className={styles.counterButton}
                        onClick={() => deleteItemSolicitud(producto,producto.producto)}
                        aria-label={`Quitar una unidad de ${nombre}`}
                    >
                        <FaMinus aria-hidden="true" />
                    </button>
                    <span className={styles.itemCount} aria-live="polite">{producto.cantidad} un.</span>
                    <button
                        type="button"
                        className={styles.counterButton}
                        onClick={() => incrementarCantidad(producto,producto.producto)}
                        disabled={atMax}
                        aria-label={`Agregar una unidad de ${nombre}`}
                    >
                        <FaPlus aria-hidden="true" />
                    </button>
                </div>
            </div>
        </li>
    );
};

const mapStateToProps = (state) => ({
    carrito: state.Solicitud.carrito,
    allProductos: state.Productos.productos // Add this to access all products
});

export default connect(mapStateToProps, {
    addItemSolicitud,
    deleteItemSolicitud,
    deleteItemSolicitudCompletamente
})(CartItem);